import { FileText } from 'lucide-react';
import { AgentLineFlie } from '@/app/components/icons/AgentLineFlie';
import { BaseLineMusic } from '@/app/components/icons/BaseLineMusic';
import { ProductLineAiVideo } from '@/app/components/icons/ProductLineAiVideo';
import { ProductLinePic } from '@/app/components/icons/ProductLinePic';
import type { MediaFilter } from '../../../types';

interface MediaTypeIconProps {
  type: MediaFilter | 'file';
}

export const MediaTypeIcon = ({ type }: MediaTypeIconProps) => {
  if (type === 'image') {
    return <ProductLinePic className="size-5" />;
  }
  if (type === 'video') {
    return <ProductLineAiVideo className="size-5" />;
  }
  if (type === 'audio') {
    return <BaseLineMusic className="size-5" />;
  }
  if (type === 'document') {
    return <FileText className="size-5" />;
  }
  return <AgentLineFlie className="size-5" />;
};
